module.exports = __webpack_public_path__ + "fonts/Baloo2-Bold.65719b3.ttf";